/*
 * A&M JOYAS - Validación de "no vendible solo" y de límite proporcional
 * para productos adicionales.
 * Un producto con el tag "producto_adicional" (estuches, cuadros, etc.) no
 * puede finalizar una compra si es el único tipo de producto en el carrito.
 * Además, si ese producto tiene un tag "max_N" (ej. "max_2"), su cantidad en
 * el carrito no puede superar N unidades por cada producto principal.
 *
 * También revisa el stock REAL de productos adicionales que son combos con
 * inventario compartido (ej. "1 unidad" / "2 unidades" del mismo marco): si
 * lo pedido en el carrito supera el stock disponible, lo ajusta ahí mismo
 * -- en vez de dejar que la clienta lo descubra recién en el checkout.
 *
 * Comportamiento:
 *  - Si el carrito queda SOLO con adicionales (sin ningún producto
 *    principal), se elimina automáticamente el/los adicionales del carrito
 *    y se muestra un aviso visible explicando por qué.
 *  - Si un adicional tiene un tag "max_N" y su cantidad excede N por cada
 *    producto principal en el carrito, se ajusta automáticamente su
 *    cantidad al máximo permitido y se muestra un aviso visible.
 *  - Si un adicional es un combo con variantes de distinta cantidad
 *    (ej. "1 unidad" / "2 unidades" que comparten el mismo stock), y la
 *    suma de lo pedido en el carrito supera el stock real disponible, se
 *    recorta la cantidad de la primera línea que se pase y se muestra un
 *    aviso visible -- esto corre al cargar el carrito y en cada cambio, no
 *    solo al llegar al checkout.
 *  - Como salvaguarda (por si el ajuste automático falla, por ejemplo
 *    por un error de red), también se bloquea el botón nativo de Checkout
 *    (carrito de pie de página y drawer) con un mensaje cuando el carrito
 *    quedó solo con adicionales.
 *  - El botón de WhatsApp tiene su propia validación en
 *    whatsapp-modal-cart.liquid.
 *
 * Nota sobre cómo se aplican los ajustes de cantidad: siempre que sea
 * posible, en vez de llamar a /cart/change.js "a mano", se simula la misma
 * interacción que haría la clienta (cambiar el valor del input de cantidad y
 * disparar su evento "change"). Así reutilizamos el mismo flujo de Dawn
 * (assets/cart.js -> CartItems.updateQuantity), que además de guardar el
 * cambio vuelve a pintar TODAS las secciones relacionadas del carrito
 * (líneas, ícono del carrito, total). Si se llamara a /cart/change.js
 * directamente sin pasar por ese flujo, el carrito quedaría desactualizado
 * en pantalla (cantidad y total viejos) hasta que algo más lo refresque.
 */
(function () {
  if (window.__addonGatingInit) return;
  window.__addonGatingInit = true;

  var ADDON_TAG = 'producto_adicional';
  var MAX_TAG_PATTERN = /^max_(\d+)$/i;
  var MENSAJE_BLOQUEO = 'Los productos adicionales (como estuches o cuadros) deben acompañar al menos un producto principal de la tienda. Agrega una joya u otro producto para poder llevarlos.';
  var tagsCache = {};
  var productDataCache = {};

  var estado = { eligible: true, checked: false };

  function fetchTags(handle) {
    if (tagsCache[handle]) return Promise.resolve(tagsCache[handle]);
    return fetchProductData(handle).then(function (p) {
      tagsCache[handle] = p.tags || [];
      return tagsCache[handle];
    });
  }

  function fetchProductData(handle) {
    if (productDataCache[handle]) return Promise.resolve(productDataCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        productDataCache[handle] = p;
        return p;
      })
      .catch(function () {
        var vacio = { tags: [], variants: [] };
        productDataCache[handle] = vacio;
        return vacio;
      });
  }

  function quitarMensajePrevio(btn) {
    var next = btn.nextElementSibling;
    if (next && next.classList && next.classList.contains('addon-gating-message')) {
      next.remove();
    }
  }

  function insertarMensaje(btn) {
    quitarMensajePrevio(btn);
    var msg = document.createElement('p');
    msg.className = 'addon-gating-message';
    msg.setAttribute('role', 'alert');
    msg.style.cssText =
      'color:#92400e;background:#fffbeb;border:1px solid #f59e0b;border-radius:8px;' +
      'padding:10px 12px;font-size:1.3rem;line-height:1.4;margin-top:10px;';
    msg.textContent = '✨ ' + MENSAJE_BLOQUEO;
    btn.insertAdjacentElement('afterend', msg);
  }

  function aplicarAlBoton(id) {
    var btn = document.getElementById(id);
    if (!btn) return;

    if (estado.eligible) {
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      quitarMensajePrevio(btn);
    } else {
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
      insertarMensaje(btn);
    }
  }

  function aplicarEstado() {
    aplicarAlBoton('checkout');
    aplicarAlBoton('CartDrawer-Checkout');
  }

  function mostrarToast(texto) {
    var previo = document.getElementById('addon-gating-toast');
    if (previo) previo.remove();

    var toast = document.createElement('div');
    toast.id = 'addon-gating-toast';
    toast.setAttribute('role', 'status');
    toast.style.cssText =
      'position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:99999;' +
      'background:#fffbeb;color:#92400e;border:1px solid #f59e0b;border-radius:8px;' +
      'padding:12px 16px;font-size:1.3rem;line-height:1.4;max-width:90vw;' +
      'box-shadow:0 4px 12px rgba(0,0,0,.15);text-align:center;';
    toast.textContent = texto;
    document.body.appendChild(toast);

    setTimeout(function () {
      if (toast.parentNode) toast.remove();
    }, 6000);
  }

  function mostrarAvisoEliminacion(nombreProducto) {
    mostrarToast(
      '✨ Quitamos "' + nombreProducto + '" de tu carrito porque necesita un producto principal ' +
      '(una joya u otro producto de la tienda) para poder llevarlo.'
    );
  }

  function mostrarAvisoAjuste(nombreProducto, cantidadPermitida, limitePorPrincipal) {
    mostrarToast(
      '✨ Ajustamos "' + nombreProducto + '" a ' + cantidadPermitida + ' unidad(es): este producto permite ' +
      'hasta ' + limitePorPrincipal + ' por cada producto principal en tu pedido.'
    );
  }

  function mostrarAvisoStockCombo(nombreProducto, cantidadPermitida) {
    var texto =
      cantidadPermitida > 0
        ? '✨ Ajustamos "' + nombreProducto + '" a ' + cantidadPermitida + ' porque ya no hay stock suficiente para más.'
        : '✨ Quitamos "' + nombreProducto + '" de tu carrito porque ya no queda stock disponible.';
    mostrarToast(texto);
  }

  // IMPORTANTE: todo lo que sigue identifica una linea del carrito por su
  // "key" (item.key, ej. "48121621676195:b3b5ecc...") -- NUNCA por su
  // posicion/indice (linea 1, linea 2...). La posicion cambia cada vez que
  // se elimina una linea anterior (todo se recorre), y como estos ajustes
  // son asincronos, usar la posicion puede terminar aplicando un cambio a
  // la linea equivocada (ej. recortar por error un producto que la clienta
  // nunca toco, justo despues de eliminar otro). La key nunca cambia.

  function inputDeLinea(key) {
    return document.querySelector('[data-quantity-line-key="' + key + '"]');
  }

  function filaDeLinea(key) {
    var input = inputDeLinea(key);
    if (!input) return null;
    return (
      input.closest('tr') ||
      input.closest('.cart-item') ||
      input.closest('[id^="CartItem-"]') ||
      input.closest('[id^="CartDrawer-Item-"]')
    );
  }

  function eliminarPorClicDeBoton(key) {
    var fila = filaDeLinea(key);
    var btn = fila && fila.querySelector('cart-remove-button');
    if (btn) {
      btn.click();
      return true;
    }
    return false;
  }

  function eliminarPorApiDirecta(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'addon-gating', cartData: cart });
        }
        revalidar();
      })
      .catch(function () {});
  }

  function ajustarCantidadPorInput(key, nuevaCantidad) {
    var input = inputDeLinea(key);
    if (!input) return false;

    input.value = nuevaCantidad;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function ajustarCantidadPorApiDirecta(key, nuevaCantidad) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: nuevaCantidad }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'addon-gating', cartData: cart });
        }
        revalidar();
      })
      .catch(function () {});
  }

  function ajustarCantidadLinea(key, nuevaCantidad) {
    if (nuevaCantidad <= 0) {
      var clicOk = eliminarPorClicDeBoton(key);
      if (!clicOk) eliminarPorApiDirecta(key);
      return;
    }
    var uiOk = ajustarCantidadPorInput(key, nuevaCantidad);
    if (!uiOk) {
      ajustarCantidadPorApiDirecta(key, nuevaCantidad);
    }
  }

  function obtenerLimitePorPrincipal(tags) {
    for (var i = 0; i < tags.length; i++) {
      var match = MAX_TAG_PATTERN.exec(tags[i]);
      if (match) return parseInt(match[1], 10);
    }
    return null;
  }

  // Cuantas unidades reales representa una variante de combo, a partir de
  // su titulo (ej. "2 unidades" -> 2, "1 unidad" -> 1). Si no encuentra un
  // numero, asume 1.
  function unidadesPorTitulo(titulo) {
    var match = /(\d+)/.exec(titulo || '');
    return match ? parseInt(match[1], 10) : 1;
  }

  var ajustandoAhora = false;

  function ajustarExcesoDeAdicionales(cart, totalPrincipalQty) {
    if (ajustandoAhora) return;

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var tags = tagsCache[item.handle] || [];
      if (tags.indexOf(ADDON_TAG) === -1) continue;

      var limite = obtenerLimitePorPrincipal(tags);
      if (limite === null) continue;

      var permitido = limite * totalPrincipalQty;
      if (item.quantity <= permitido) continue;

      ajustandoAhora = true;
      mostrarAvisoAjuste(item.product_title || item.title, permitido, limite);
      ajustarCantidadLinea(item.key, permitido);

      setTimeout(function () {
        ajustandoAhora = false;
      }, 1200);

      return;
    }
  }

  // Revisa productos adicionales que son combos con inventario compartido
  // (mas de una variante, ej. "1 unidad" / "2 unidades" del mismo marco).
  // Si la suma de unidades reales pedidas en el carrito (sumando todas las
  // lineas de ese mismo producto) supera el stock real disponible, recorta
  // la primera linea que se pase para calzar en el stock -- en vez de
  // dejar que el carrito muestre una cantidad que ya no es real hasta que
  // la clienta llegue al checkout.
  //
  // El stock real NO se puede pedir por la API publica del carrito
  // (/products/handle.js nunca trae el numero de inventario, solo
  // "available: true/false"). Por eso se usa window.addonComboStock, un
  // bloque que theme.liquid arma con Liquid (que si tiene acceso al stock
  // real) y deja listo en la pagina desde que carga -- ver ese archivo
  // para agregar un nuevo producto combo a la lista.
  var ajustandoStockAhora = false;

  function ajustarExcesoDeStockCombo(cart) {
    if (ajustandoStockAhora) return;
    if (!window.addonComboStock) return;

    for (var handle in window.addonComboStock) {
      if (!Object.prototype.hasOwnProperty.call(window.addonComboStock, handle)) continue;

      var variantesStock = window.addonComboStock[handle];
      if (!variantesStock || variantesStock.length < 2) continue; // no es combo

      var lineasDeEsteProducto = [];
      cart.items.forEach(function (item) {
        if (item.handle === handle) {
          lineasDeEsteProducto.push({ item: item, key: item.key });
        }
      });
      if (!lineasDeEsteProducto.length) continue;

      // Stock real = inventario de la variante de menor cantidad
      // (normalmente "1 unidad"), que Shopify calcula automaticamente a
      // partir del componente compartido.
      var variantesOrdenadas = variantesStock.slice().sort(function (a, b) {
        return unidadesPorTitulo(a.title) - unidadesPorTitulo(b.title);
      });
      var stockDisponible = variantesOrdenadas[0].inventory_quantity;
      if (typeof stockDisponible !== 'number') continue; // sin tracking, no tocar

      var totalPedido = 0;
      lineasDeEsteProducto.forEach(function (l) {
        totalPedido += l.item.quantity * unidadesPorTitulo(l.item.variant_title || l.item.title);
      });

      if (totalPedido <= stockDisponible) continue;

      // Hay que recortar: vamos linea por linea (en el orden en que
      // aparecen en el carrito) hasta calzar en el stock real.
      var restante = stockDisponible;
      for (var i = 0; i < lineasDeEsteProducto.length; i++) {
        var l = lineasDeEsteProducto[i];
        var unidades = unidadesPorTitulo(l.item.variant_title || l.item.title);
        var maxCantidadPermitida = unidades > 0 ? Math.floor(restante / unidades) : 0;

        if (l.item.quantity > maxCantidadPermitida) {
          ajustandoStockAhora = true;
          mostrarAvisoStockCombo(l.item.product_title || l.item.title, maxCantidadPermitida);
          ajustarCantidadLinea(l.key, maxCantidadPermitida);

          setTimeout(function () {
            ajustandoStockAhora = false;
          }, 1200);

          return;
        }

        restante -= l.item.quantity * unidades;
      }
    }
  }

  var eliminandoAhora = false;

  function eliminarPrimerAdicional(cart) {
    if (eliminandoAhora) return;

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var tags = tagsCache[item.handle] || [];
      if (tags.indexOf(ADDON_TAG) === -1) continue;

      eliminandoAhora = true;
      mostrarAvisoEliminacion(item.product_title || item.title);

      var clicOk = eliminarPorClicDeBoton(item.key);
      if (!clicOk) {
        eliminarPorApiDirecta(item.key);
      }

      setTimeout(function () {
        eliminandoAhora = false;
      }, 1200);

      return;
    }
  }

  function revalidar() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          estado.eligible = true;
          estado.checked = true;
          aplicarEstado();
          return;
        }

        var handles = [];
        cart.items.forEach(function (item) {
          if (handles.indexOf(item.handle) === -1) handles.push(item.handle);
        });

        return Promise.all(handles.map(fetchTags)).then(function () {
          var totalPrincipalQty = 0;
          cart.items.forEach(function (item) {
            var tags = tagsCache[item.handle] || [];
            if (tags.indexOf(ADDON_TAG) === -1) totalPrincipalQty += item.quantity;
          });
          var hayPrincipal = totalPrincipalQty > 0;

          estado.eligible = hayPrincipal;
          estado.checked = true;
          aplicarEstado();

          if (!hayPrincipal) {
            eliminarPrimerAdicional(cart);
          } else {
            ajustarExcesoDeAdicionales(cart, totalPrincipalQty);
            ajustarExcesoDeStockCombo(cart);
          }
        });
      })
      .catch(function () {
        estado.eligible = true;
        estado.checked = true;
        aplicarEstado();
      });
  }

  var observer = new MutationObserver(function () {
    if (estado.checked) aplicarEstado();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  function suscribirse() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, revalidar);
      revalidar();
    } else {
      setTimeout(suscribirse, 250);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', suscribirse);
  } else {
    suscribirse();
  }

  document.addEventListener(
    'submit',
    function (e) {
      var submitter = e.submitter;
      if (!submitter || (submitter.id !== 'checkout' && submitter.id !== 'CartDrawer-Checkout')) return;
      if (estado.checked && !estado.eligible) {
        e.preventDefault();
        alert('⚠️ ' + MENSAJE_BLOQUEO);
      }
    },
    true
  );
})();
